import React, { useEffect, useState } from 'react';
import useWebSocket from 'react-use-websocket';
import { WebsocketMessageData } from "../types/websockets";

interface Props {
    setWsMessageHandler: Function
}

// персональный сокет юзера chat_messages.{user_pk} сюда бэк шлёт точный счётчик непрочитанных
export const UserWebsocket = ({ setWsMessageHandler }: Props) => {
    const [socketUrl] = useState(`${process.env.REACT_APP_WEBSOCKET_URL}chats/?jwt=${localStorage.getItem('xAuthToken')}`);

    // share общий сокет между списком и заявкой переживает spa навигацию shouldReconnect поднимает после обрыва
    const { lastMessage } = useWebSocket(socketUrl, {
        share: true,
        shouldReconnect: () => true,
        reconnectAttempts: 1000,
        reconnectInterval: 3000,
    });

    useEffect(() => {
        if (lastMessage !== null) {
            const msg: WebsocketMessageData = JSON.parse(lastMessage.data);
            console.log('wsMessage user: ', msg)
            setWsMessageHandler(msg);
        }
    }, [lastMessage]);

    return <></>;
};
